import { apiInstanceUnauthorized } from 'api/utils';

const usersApi = {
  login: ({ email, password }: { email: string; password: string }) => {
    return apiInstanceUnauthorized.request({
      method: 'POST',
      url: '/users/login/',
      data: {
        email,
        password
      }
    });
  },

  getCsrf: () => {
    return apiInstanceUnauthorized.request({
      method: 'GET',
      url: '/users/csrf/'
    });
  },

  getUserProfile: () => {
    return apiInstanceUnauthorized.request({
      method: 'GET',
      url: '/users/me/'
    });
  },

  createUserProfile: () => {
    return apiInstanceUnauthorized.request({
      method: 'POST',
      url: '/users/me/'
    });
  },

  updateUserPassword: ({
    current_password,
    new_password,
    confirm_password
  }: {
    current_password: string;
    new_password: string;
    confirm_password: string;
  }) => {
    return apiInstanceUnauthorized.request({
      method: 'POST',
      url: '/users/password-update/',
      data: {
        current_password,
        new_password,
        confirm_password
      }
    });
  },

  logout: () => {
    return apiInstanceUnauthorized.request({
      method: 'POST',
      url: '/users/logout/'
    });
  },

  requestPasswordReset: (email: string) => {
    return apiInstanceUnauthorized.request({
      method: 'POST',
      url: '/users/request-password-reset/',
      data: {
        email
      }
    });
  },

  checkPasswordReset: (userId: number, token: string) => {
    return apiInstanceUnauthorized.request({
      method: 'GET',
      url: `/users/password-reset/${userId}/${token}/`
    });
  },

  resetPassword: (
    userId: number,
    password: string,
    confirm_password: string
  ) => {
    return apiInstanceUnauthorized.request({
      method: 'POST',
      url: '/users/password-reset/',
      data: {
        user_id: userId,
        password,
        confirm_password
      }
    });
  }
};

export default {
  ...usersApi
};
